<template>
    <div></div>
</template>

<script>
export default {
    created() {
        localStorage.clear();
        //this.$router.go(-1);
        this.$router.push({name:"index"});
    },
}
</script>
